import HelpIcon from "@mui/icons-material/Help";
import PersonIcon from "@mui/icons-material/Person";

import {
	Alert,
	AppBar,
	Avatar,
	Box,
	Button,
	FormControl,
	IconButton,
	MenuItem,
	Select,
	Toolbar,
	Tooltip,
	Typography,
} from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { lngs } from "../../../constants";

export const Preview = ({ watch }) => {
	const { t } = useTranslation();
	const messagePL = watch("message-pl");
	const messageEN = watch("message-en");
	const messageCZ = watch("message-cz");
	const type = watch("type") || "success";
	const shouldShow = watch("isVisible") || false;
	const links = watch("links") || [];

	const [lang, setLang] = useState("pl");

	return (
        <Box sx={{ flex: "0 0 960px" }}>
            <Box
				sx={{
					display: "flex",
					justifyContent: "space-between",
					alignItems: "center",
					mb: 1,
				}}
			>
				<Typography variant="h6">Preview (FullHD - 1920x1080)</Typography>
				<Box
					sx={{
						backgroundColor: "#f2f2f2",
						p: "8px 4px 4px 4px",
						borderRadius: "2px",
					}}
				>
					<FormControl variant="standard" size="small">
						<Select
							labelId="language-select-label"
							value={lang}
							onChange={(e) => setLang(e.target.value)}
							sx={{ minWidth: 120, pb: 0 }}
						>
							{Object.entries(lngs).map(([code, { nativeName, flagUrl }]) => (
								<MenuItem key={code} value={code}>
									<Box
                                        sx={{
                                            alignItems: "center",
                                            display: "flex"
                                        }}>
										<Avatar
											src={flagUrl}
											alt={nativeName}
											sx={{ width: 18, height: 18, marginRight: 1 }}
										/>
										{nativeName}
									</Box>
								</MenuItem>
							))}
						</Select>
					</FormControl>
				</Box>
			</Box>
            <Box
				sx={{
					width: "100%",
					maxWidth: "960px",
					aspectRatio: "16/9",
					border: "2px solid #000",
					overflow: "hidden",
					transform: "scale(1)",
					transformOrigin: "top left",
				}}
			>
				<Box
					sx={{
						width: "1920px",
						height: "1080px",
						transform: "scale(0.5)",
						transformOrigin: "top left",
						display: "flex",
						flexDirection: "column",
					}}
				>
					<AppBar
						position="sticky"
						sx={{
							background: "#F2F2F2",
							boxShadow: "none",
							height: "49px",
						}}
					>
						<Toolbar
							sx={{
								display: "flex",
								justifyContent: "end",
								position: "relative",
							}}
							variant="dense"
						>
							<Box sx={{ mr: "20px" }}>
								<Box
									sx={{
										backgroundColor: "#f2f2f2",
										p: "8px 4px 4px 4px",
										borderRadius: "2px",
									}}
								>
									<FormControl variant="standard" size="small">
										<Select
											labelId="language-select-label"
											value={lang}
											onChange={(e) => setLang(e.target.value)}
											sx={{ minWidth: 120, pb: 0 }}
										>
											{Object.entries(lngs).map(
												([code, { nativeName, flagUrl }]) => (
													<MenuItem key={code} value={code}>
														<Box
                                                            sx={{
                                                                alignItems: "center",
                                                                display: "flex"
                                                            }}>
															<Avatar
																src={flagUrl}
																alt={nativeName}
																sx={{ width: 18, height: 18, marginRight: 1 }}
															/>
															{nativeName}
														</Box>
													</MenuItem>
												),
											)}
										</Select>
									</FormControl>
								</Box>
							</Box>
							<Box
								sx={{
									display: "flex",
									flexDirection: "column",
									alignItems: "end",
									justifyContent: "center",
								}}
							>
								<Box
									sx={{
										display: "flex",
										alignItems: "center",
										gap: "4px",
										pr: "3px",
									}}
								>
									<PersonIcon sx={{ color: "#A6A6A6", fontSize: "14px" }} />
									<Typography sx={{ color: "#A6A6A6", fontSize: "12px" }}>
										Jan Kowalski
									</Typography>
								</Box>
								<Button
									sx={{ color: "#0070C0", pr: 0, py: 0 }}
									loading={false}
									variant="text"
									onClick={() => {}}
								>
									{t("sign_out")}
								</Button>
							</Box>
							<Tooltip
								title={
									<Typography
										variant="p"
										sx={{ fontSize: "9pt" }}
										component="span"
									>
										{t("show_tour_guide")}
									</Typography>
								}
								placement="bottom"
							>
								<IconButton
									aria-label="guide"
									size="small"
									onClick={() => {}}
									sx={{ ml: "20px" }}
								>
									<HelpIcon fontSize="small" />
								</IconButton>
							</Tooltip>
						</Toolbar>
					</AppBar>
					{shouldShow && (
						<Alert
							variant="filled"
							severity={type}
							onClose={() => {}}
							sx={{
								borderRadius: 0,
								width: "100%",
								display: "flex",
								justifyContent: "start",
								alignItems: "center",
								"& .MuiAlert-message": {
									width: "100%",
								},
							}}
						>
							<Box
								sx={{
									display: "flex",
									alignItems: "center",
									justifyContent: "flex-start",
									gap: 2,
									width: "100%",
								}}
							>
								<Typography
									sx={{
										color: "#fff",
										display: "flex",
										alignItems: "center",
										gap: "2px",
									}}
								>
									{lang === "pl" && messagePL}
									{lang === "en" && messageEN}
									{lang === "cz" && messageCZ}
								</Typography>
								<Box>
									{links.length > 0 && (
										<Box sx={{ display: "flex", gap: 1, ml: "auto" }}>
											{links.map(
												(link, index) =>
													link.text &&
													link.url && (
														<Button
															key={index}
															href={link.url}
															target="_blank"
															rel="noopener noreferrer"
															sx={{
																color: "#fff",
																textDecoration: "underline",
																minWidth: "auto",
																padding: "2px 8px",
																fontSize: "0.875rem",
																"&:hover": {
																	backgroundColor: "rgba(255, 255, 255, 0.1)",
																},
															}}
														>
															{link.text}
														</Button>
													),
											)}
										</Box>
									)}
								</Box>
							</Box>
						</Alert>
					)}
				</Box>
			</Box>
        </Box>
    );
};
